module.exports = __webpack_public_path__ + "static/media/leaf.b8f4da01.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/leaf.png
// module id = 1942
// module chunks = 0